export const CARE_ORDER_PLAN_KEY = {
    ALL_DAY: 'ALL_DAY',
    PART_TIME_8: 'PART_TIME_8',
    PART_TIME_10: 'PART_TIME_10',
    PART_TIME_12: 'PART_TIME_12',
};
export const PART_TIME_CARE_ORDER_PLAN_KEY_HOUR_MAP = {
    8: CARE_ORDER_PLAN_KEY.PART_TIME_8,
    10: CARE_ORDER_PLAN_KEY.PART_TIME_10,
    12: CARE_ORDER_PLAN_KEY.PART_TIME_12,
};
export const CARE_ORDER_PLAN_DESCRIPTION = {
    ALL_DAY: '為家人安排一位全天在旁協助、照顧的照服員',
    PART_TIME_8: '在您上班、有外務的日子，安排一位照服員每天照顧 8 小時',
    PART_TIME_10: '在您上班、有外務的日子，安排一位照服員每天照顧 10 小時',
    PART_TIME_12: '為家人安排每天 12 小時的半日照顧',
};
